import { Environment } from './../app/shared/models/Environment.model';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: Environment = {
  production: false,
  env: "Dev",
  versionCode: 375,
  versionNumber: "8.1.2",
  Recaptcha: "6LcO6UUlAAAAALkc626JitEs1iLTBYTMuwBwjAMz",
  appname: "Gepp-Dev-Lealtad-Web"
  , crypto: {
    encrypt: true,
    keyEncrypt: "y#P$3dR?HTvOKZ20"
  }
  , url: "https://us-central1-gepp-dev.cloudfunctions.net/"
  , urlApiV2: "https://multiplica-lab.eastus2.cloudapp.azure.com/gepp/getm/dev"
  , connectorType: "HTTP"
  , enviromentAnalytics: "dev"
  , i18n: "https://getm-assets-dev.servicesgepp.com/getm-dev-resources-assets/i18n/"
  , firebaseConfig: {
    apiKey: "AIzaSyAf2XJGZmpD0r35rvnQuXld2y6rOCh0iHQ",
    authDomain: "gepp-dev.firebaseapp.com",
    databaseURL: "https://gepp-dev.firebaseio.com",
    projectId: "gepp-dev",
    storageBucket: "gepp-dev.appspot.com",
    messagingSenderId: "407330824097",
    appId: "1:407330824097:web:411fe19a5499e5ad",
    measurementId: "G-4J7R37NZY6",
    webPushKey: "BASIv_UqRmFefSyKE1iOSP41rMAkoetV79qcB4fqjeQ1GBNQRPTP4V6jbzFnuIQ6I_Jj0m75i8uqIVnv5t5Iw6c"
  },
  sentry: {
    environment: "dev",
    serviceName: "getm-ionic-test",
    dsn: "https://2ab7c3068ed4edb2532e27c8f8a3a20e@o4510942419681280.ingest.us.sentry.io/4510943228133376",
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
  },
  azureCA: {
    gamificacion: "https://ca-getm-gamificacion-dev.servicesgepp.com",
    autoevaluacion: "https://ca-getm-foto-exito-dev.servicesgepp.com",
    integraciones: "https://ca-getm-serv-integraciones-dev.servicesgepp.com",
    gestion_tickets: "https://ca-getm-serv-gestion-tickets-dev.servicesgepp.com",
    contenido: "https://ca-getm-gest-contenido-dev.servicesgepp.com",
    usuarios: "https://ca-getm-gest-usuarios-dev.servicesgepp.com"
    // Agregar otros servicios de Azure Container Apps aquí - Irse a HttpStatusCodes.ts y agregar la llave en AZURE_CA_URLS
  },
  url_assets: "https://getm-assets-dev.servicesgepp.com/getm-dev-resources-assets/"
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import "zone.js/plugins/zone-error";  // Included with Angular CLI.
